/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_IntroInputs */

const es_landing_pricing_intro = /** @type {(inputs: Landing_Pricing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ley obliga a que una gestora autorizada tramite el cambio de uso. Podríamos cobrar de más por ese papel imprescindible — hacemos justo lo contrario. Solo pagas en dos momentos.`)
};

const gl_landing_pricing_intro = /** @type {(inputs: Landing_Pricing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lei obriga a que unha xestora autorizada tramite o cambio de uso. Poderíamos cobrar de máis por ese papel imprescindible — facemos xusto o contrario. Só pagas en dous momentos.`)
};

const en_landing_pricing_intro = /** @type {(inputs: Landing_Pricing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The law requires an authorised manager to process the change of use. We could charge extra for that essential paperwork — we do the opposite. You only pay at two points.`)
};

/**
* | output |
* | --- |
* | "The law requires an authorised manager to process the change of use. We could charge extra for that essential paperwork — we do the opposite. You only pay at..." |
*
* @param {Landing_Pricing_IntroInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_intro = /** @type {((inputs?: Landing_Pricing_IntroInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_IntroInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_pricing_intro(inputs)
	if (locale === "en") return en_landing_pricing_intro(inputs)
	return es_landing_pricing_intro(inputs)
});